export default __webpack_public_path__ + "static/media/misc-closetC-768w.5a51db7e.webp";